<template>
  <div class="iq-sidebar">
    <div class="iq-sidebar-logo d-flex justify-content-between mb-5">
      <router-link :to="homeURL">
        <img :src="logo" class="img-fluid" alt="logo">
      </router-link>
      <div class="iq-menu-bt-sidebar" v-if="toggleButton">
        <div class="iq-menu-bt align-self-center">
          <div class="wrapper-menu" :class="{'open' : isMini}" @click="miniSidebar">
            <div class="main-circle"><i class="ri-arrow-left-s-line"></i></div>
            <div class="hover-circle"><i class="ri-arrow-left-s-line"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div id="sidebar-scrollbar">
      <nav class="iq-sidebar-menu" :class="horizontal ? 'd-xl-none' : ''">
        <List :items="items" :open="true" :horizontal="horizontal"/>
      </nav>
      <div class="p-3"></div>
    </div>
  </div>
  <!-- TOP Nav Bar -->
</template>

<script>
import List from '../menus/ListStyle1'
export default {
  name: 'SideBarStyle1',
  props: {
    homeURL: { type: Object, default: () => ({ name: 'dashboard.home' }) },
    items: { type: Array },
    logo: { type: String, default: require('../../../assets/images/logo-API.png') },
    horizontal: { type: Boolean },
    toggleButton: { type: Boolean, default: true }
  },
  components: {
    List
  },
  computed: {
    isMini () {
      return this.$store.getters['Setting/miniSidebarState']
    }
  },
  methods: {
    miniSidebar () {
      this.$emit('toggle')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.iq-menu-bt { opacity: 0; display: block !important; }
</style>